// ---------------------------------------------------------------------------
// Changelog — version history shown to users after a software update.
// Keep CURRENT_VERSION in sync with CACHE_VERSION in public/sw.js.
// ---------------------------------------------------------------------------

export const CURRENT_VERSION = '2.1.0';

export type ChangelogItemType = 'feature' | 'fix' | 'improvement';

export interface ChangelogItem {
  type: ChangelogItemType;
  key: string;
}

export interface ChangelogEntry {
  version: string;
  date: string;
  items: ChangelogItem[];
}

export const CHANGELOG: ChangelogEntry[] = [
  {
    version: '2.1.0',
    date: '2026-08-08',
    items: [
      { type: 'feature', key: 'shared.changelog.items.aiFeatures25' },
      { type: 'feature', key: 'shared.changelog.items.seoLandingPages' },
      { type: 'improvement', key: 'shared.changelog.items.softwareUpdateFlow' },
      { type: 'improvement', key: 'shared.changelog.items.i18nAiTranslations' },
      { type: 'fix', key: 'shared.changelog.items.seoFileSplits' },
    ],
  },
  {
    version: '2.0.0',
    date: '2026-07-15',
    items: [
      { type: 'feature', key: 'shared.changelog.items.offlineResilience' },
      { type: 'feature', key: 'shared.changelog.items.multiTabSync' },
      { type: 'feature', key: 'shared.changelog.items.pwaInstall' },
      { type: 'improvement', key: 'shared.changelog.items.precacheStrategy' },
      { type: 'fix', key: 'shared.changelog.items.swCacheConflicts' },
    ],
  },
  {
    version: '1.0.0',
    date: '2026-06-01',
    items: [
      { type: 'feature', key: 'shared.changelog.items.initialRelease' },
      { type: 'feature', key: 'shared.changelog.items.modules36' },
      { type: 'feature', key: 'shared.changelog.items.multiLanguage9' },
      { type: 'feature', key: 'shared.changelog.items.darkLuxuryTheme' },
    ],
  },
];
